import { render, staticRenderFns } from "./PressReleases.vue?vue&type=template&id=c6520108&"
import script from "./PressReleases.vue?vue&type=script&lang=js&"
export * from "./PressReleases.vue?vue&type=script&lang=js&"
import style0 from "./PressReleases.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports